import { isNumber, isFinite, ceil } from 'lodash';
export function convertSToMS(durationSec) {
    return isNumber(durationSec) && isFinite(durationSec)
        ? ceil(durationSec * 1000)
        : null;
}
//# sourceMappingURL=time.js.map